import type { Action } from '@reduxjs/toolkit';
import { isRecord } from 'utils/typeChecks';

const isDocumentMutation = (value: unknown): boolean => isRecord(value) && value.endpointName === 'createOnlyOfficeSession';

export const sanitizeDocumentAction = <A extends Action>(action: A): A => {
  const candidate: unknown = action;
  if (!isRecord(candidate) || !isRecord(candidate.meta) || !isDocumentMutation(candidate.meta.arg)) return action;
  return { ...action, payload: '[redacted]', meta: { ...candidate.meta, baseQueryMeta: undefined } };
};

export const sanitizeDocumentState = <S>(state: S): S => {
  if (!isRecord(state) || !isRecord(state.flowApi) || !isRecord(state.flowApi.mutations)) return state;
  return {
    ...state,
    flowApi: {
      ...state.flowApi,
      mutations: Object.fromEntries(
        Object.entries(state.flowApi.mutations).map(([key, value]) => [
          key,
          isRecord(value) && isDocumentMutation(value) ? { ...value, data: '[redacted]' } : value,
        ])
      ),
    },
  };
};
